import DataGrid from 'components/DataGrid';
import { useCommitteeTicket } from '../../hooks/useCommitteeTicket';
import { Grid } from '@mui/material';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { FormProvider } from 'react-hook-form';
import { I18n } from 'utilities/utilities';
import { useState } from 'react';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';

const CommitteeTicketList = () => {

    //#region Hook
    const {
        dataColumn,
        formSearch,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        lstStatus,
        handleClearSearch
    } = useCommitteeTicket()
    // #endregion
    const [startDate, setStartDate] = useState(null);


    return (
        <Grid container spacing={1} justifyContent={'flex-start'}>
            <Grid item xs={12} >
                <FormProvider {...formSearch}>
                    <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                        <Grid item xs={12} sm={4} md={2.5}>
                            <DatePickerItem
                                id={`nStartDate`}
                                name={`nStartDate`}
                                label={`${I18n.SetText("Ticket.DateSoldStart")}`}
                                fullWidth
                                onChange={(e) => {
                                    setStartDate(e);
                                    if (e) {
                                        formSearch.setValue("sDateEnd", null);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2.5}>
                            <DatePickerItem
                                id={`nEndDate`}
                                name={`nEndDate`}
                                label={`${I18n.SetText("Ticket.DateSoldEnd")}`}
                                minDate={startDate}
                                fullWidth
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <MultipleSelectItem
                                id={"arrStatusId"}
                                name={"arrStatusId"}
                                label={`${I18n.SetText("Ticket.Status")}`}
                                required={false}
                                options={lstStatus}
                            />
                        </Grid>
                        <Grid item xs={12} md={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
                <DataGrid
                    columns={dataColumn}
                    isShowCheckBox={false}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isHiddenFooter={dataRow.arrRows.length === 0}
                    onDelete={onDelete}
                    sTableID='gtCommittee'
                    isHiddenToolHead
                />
            </Grid>
        </Grid>
    )
}

export default CommitteeTicketList
